import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserModel } from 'src/app/models/dto/user.model';
import { ModalConfig } from 'src/app/pages/modal-scheda-prod/moda-scheda-prod.config';
import { ModalSchedaProdComponent } from 'src/app/pages/modal-scheda-prod/modal-scheda-prod.component';
import { ModalSchedaProd2Component } from 'src/app/pages/modal-scheda-prod2/modal-scheda-prod2.component';
import { SchedaProdottoComponent } from 'src/app/pages/scheda-prodotto/scheda-prodotto.component';
import { GeneralServiceService } from 'src/app/services/general-service.service';

@Component({
  selector: 'app-prodotti-lista',
  templateUrl: './prodotti-lista.component.html',
  styleUrls: ['./prodotti-lista.component.scss']
})
export class ProdottiListaComponent implements OnInit {
  @Input() arrProdotti: any[] = [];
  @Input() titolo: string = "";
  @Input() numCol: any = "";
  @ViewChild('modal2') private modal: ModalSchedaProd2Component;
  @ViewChild('schedaProd2') childSchedaProd: SchedaProdottoComponent;
  loggato: boolean = false;
  user: UserModel;
  qty: any = 1;
  idProdotto: any;
  estero: any;
  public modalConfig: ModalConfig = {
    modalTitle: "Scheda Prodotto",
    onDismiss: () => {
      return false
    },
    dismissButtonLabel: "",
    onClose: () => {
      return true
    },
    closeButtonLabel: "Chiudi"
  }


  


navigationSubscription;


  constructor(private router: Router, private genericFunction: GeneralServiceService, private toastr: ToastrService) { 
    this.user = new UserModel(null,null,null,null,null,null,null); 
  }

  ngOnInit(): void {
   
    this.loggato = this.genericFunction.loggato;
    this.user = this.genericFunction.currentUser;
    this.estero = this.genericFunction.estero;
    console.log(this.loggato);
    this.genericFunction.subjectLoggato.subscribe((loggatoNew: boolean) => {
      this.loggato = loggatoNew;
    });
  }

  

  dettaglioProdotto(prodotto) {
    let currentUrl = "/schedaProdotto/"+prodotto.idprod;
 
      this.router.routeReuseStrategy.shouldReuseRoute = function(){return false;};
 
   //let currentUrl = this.router.url + '?';
 
   this.router.navigateByUrl(currentUrl)
     .then(() => {
       this.router.navigated = false;
       this.router.navigate([this.router.url]);
     });
    
   }

   addQty(index) {
    this.arrProdotti[index].qty = this.arrProdotti[index].qty + 1;
  }

  removeQty(index) {
    if (this.arrProdotti[index].qty > 1 ) {
      this.arrProdotti[index].qty = this.arrProdotti[index].qty - 1;
    }
  }

   addCart(prodotto) {
    let idProd: any;
    if (prodotto.InPromo != 0) {
      idProd = prodotto.InPromo;
    } else {
      idProd = prodotto.idprod;
    }
     let datiCart = {func: "aggCar", id: idProd, qta: prodotto.qty, idcar: this.genericFunction.idCart, idut: this.genericFunction.currentUser.idut, token: this.genericFunction.currentToken}
     this.genericFunction.genericFunction(datiCart).subscribe(response => {
      console.log(response);
      if (response.Esito == "ok") {
        this.toastr.success(response.messaggio);
        this.genericFunction.totCart = response.totProdCar;
        this.genericFunction.idCart = response.idcarrello;
        this.genericFunction.changeItemCart(response.totProdCar);
      } else {
        this.toastr.error(response.messaggio);
      }
     });
   }

   async openModal(idProd) {
    this.idProdotto = idProd;
    this.childSchedaProd.getDatiProdotto(idProd);
    return await this.modal.open()
  }

  async closeModal(msg){
    return await this.modal.close()
  }

}
